<template>
  <div id="q-app">
    <Loading v-if="appIsLoading" />
    <router-view v-else />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import pDebounce from "p-debounce";
import PQueue from "p-queue";
import { setItem } from "src/idb.worker.js";
import Loading from "src/components/Loading";
import { notifyError } from "src/notifyError";

function createWriter(key, onlyMotorista) {
  const queue = new PQueue({ concurrency: 1 });

  return async function (newVal, oldVal) {
    if (!this.initialisedStore) return null;
    if (onlyMotorista && !this.isMotorista) return null;

    this.$store.commit('setWriting', [key, true]);
    try {
      await queue.add(async () => {
        // console.time(`[Write] ${key}`);
        try {
          await setItem(key, newVal);
        } catch (err) {
          notifyError(err);
        } finally {
          // console.timeEnd(`[Write] ${key}`);
        }
      });
    } finally {
      this.$store.commit('setWriting', [key, false]);
    }
  };
}

export default {
  name: "App",
  components: {
    Loading,
  },
  computed: {
    ...mapState([
      "initialisedStore",
      "emissores",

      "accessToken",
      "empresaId",

      "empresas",
      "usuarios",
      "veiculos",
      "viagens",
      "checagens",
      "ocorrencias",
      "cargas",
      "pedidos",
      "clientes",
      "entregas",
      "entregas_imagens",
      "upsert_entregas",
      "itens",
      "motivos",
      "viagem_carga",
      "emissores",
      "ajustes",
    ]),
    ...mapGetters([
      "appIsLoading",
      "isMotorista",
      "usuario",
      "loggedIn",
      // "toWrite",
    ]),
    wow() {
      return [this.isMotorista, this.emissores];
    },
  },
  watch: {
    wow([isMotorista, emissores]) {
      if (isMotorista) {
        for (const e of emissores) {
          if (e.logo_url) {
            const preloadLink = document.createElement("link");
            preloadLink.href = e.logo_url;
            preloadLink.rel = "preload";
            preloadLink.as = "image";
            document.head.appendChild(preloadLink);
          }
        }
      }
    },
    usuario: {
      immediate: true,
      handler(u) {
        if (u && u.nome) {
          document.title = `Gestão de Entregas - ${u.nome}`;
        } else {
          document.title = "Gestão de Entregas";
        }
        // eslint-disable-next-line
        // gtag('config', 'G-ZG5HSRZRC8', { user_id })
      },
    },
    isMotorista: {
      immediate: true,
      handler() {
        this.handleSync();
      },
    },

    /* sync */
    accessToken: createWriter("accessToken", false),
    empresaId: createWriter("empresaId", false),

    empresas: createWriter("empresas", true),
    usuarios: createWriter("usuarios", true),
    veiculos: createWriter("veiculos", true),
    viagens: createWriter("viagens", true),
    checagens: createWriter("checagens", true),
    ocorrencias: createWriter("ocorrencias", true),
    cargas: createWriter("cargas", true),
    pedidos: createWriter("pedidos", true),
    clientes: createWriter("clientes", true),
    entregas: createWriter("entregas", true),
    entregas_imagens: createWriter("entregas_imagens", true),
    upsert_entregas: createWriter("upsert_entregas", true),
    itens: createWriter("itens", true),
    motivos: createWriter("motivos", true),
    viagem_carga: createWriter("viagem_carga", true),
    emissores: createWriter("emissores", true),
    ajustes: createWriter("ajustes", true),
  },
  created() {
    this.intervalId = null;
  },
  mounted() {
    function setStyleVarVH() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    window.addEventListener('resize', setStyleVarVH);
    setStyleVarVH();
    window.addEventListener("blur", () => {
      this.stopSync();
      this.$store.commit("lostFocus");
    });
    window.addEventListener("focus", () => {
      this.startSync();
      this.$store.commit("gainedFocus");
    });
    window.addEventListener("online", () => {
      this.stopSync();
      this.$store.commit("lostConnection");
    });
    window.addEventListener("offline", () => {
      this.startSync();
      this.$store.commit("gainedConnection");
    });
  },
  methods: {
    startSync() {
      if (this.intervalId !== null) return;
      if (!this.isMotorista) return;
      this.handleSync();
      this.intervalId = setInterval(() => this.handleSync(), 3 * 60 * 1000);
    },
    stopSync() {
      if (this.intervalId === null) return;
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    handleSync: pDebounce(function () {
      if (this.isMotorista) {
        return this.$store.dispatch("sync");
      }
    }, 300),
  },
};
</script>
